import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { SettingsService } from '../../services/settings.service';
import { SettingsModel } from '../../models/settings.model';
import { SurveyQuestionModel } from 'app/core/models/survey-question-response.model';
import { SurveyResponseService } from 'app/core/services/survey-response.service';

@Injectable()
export class SurveyQuestionResolver  {

    constructor(private service: SurveyResponseService)
    {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<SurveyQuestionModel> {
        return this.service.GetSurveyQuestion(route.data.survey_question_id);
  }
}
